import { AbgSxProps } from '@abg/typings';

export const containerStyling: AbgSxProps = {
  height: '100%',
  cursor: 'pointer',
  display: 'grid',
  gridTemplateRows: 'subgrid',
  gridRow: 'span 2',
  boxShadow: 'none',
};
